/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, November 26th 2021, 8:49:57 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { OSAPIForm, OSLoadingButton, VerticalStackWidget, FormControl } from "ui-widgets";
import { AuthFooter } from "./AuthFooter";
import { LoginLink } from "./LoginLink";
import { ForgotPasswordLink } from "./ForgotPasswordLink";

export const ReusableAuthForm = ({
  useAPIFormReturn,
  children,
  title,
  description,
  showLoginLink = false,
  showForgotPasswordLink = false,
}) => {
  return (
    <OSAPIForm useAPIFormReturn={useAPIFormReturn} showSubmitButton={false}>
      {/* <div className="auth-brand-wrapper">
        <img className="image-style-A sidebar-logo" src="/img/onestop-full-logo.svg" />
      </div> */}

      <div className="auth-form-box">
        <div className="auth-title-wrapper">
          <h1>{title}</h1>
          <p>{description}</p>
        </div>

        <div className="form-fields-A">
          <div className="main-form-fields">
            {children}

            <FormControl>
              <VerticalStackWidget>
                <OSLoadingButton
                  className="button-style-A"
                  variant="contained"
                  size="large"
                  type="submit"
                  color="primary"
                  isLoading={useAPIFormReturn?.isSendingDataToAPI}
                >
                  Continue
                </OSLoadingButton>
              </VerticalStackWidget>
            </FormControl>
            <p className="auth-form-option">
              {showLoginLink && <LoginLink />}
              {showForgotPasswordLink && <ForgotPasswordLink />}
            </p>
          </div>

          <AuthFooter />
        </div>
      </div>
    </OSAPIForm>
  );
};
